import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errorText } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthLayout } from "@/components/brand/AuthLayout";
import { FormError, FormSuccess } from "@/components/brand/Field";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState({ status: "working", message: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) return setState({ status: "error", message: "This link is missing its token." });
    api.post("/auth/verify-email", { token })
      .then(() => { setState({ status: "ok", message: "Your email is confirmed." }); refresh(); })
      .catch((e) => setState({ status: "error", message: errorText(e) }));
  }, [params, refresh]);

  return (
    <AuthLayout title="Email confirmation" footer={<Link className="ts-link" to="/app" data-testid="verify-continue-link">Continue to your account</Link>}>
      {state.status === "working" && <p className="text-sm" data-testid="verify-working">Checking your link…</p>}
      <FormSuccess message={state.status === "ok" ? state.message : ""} testId="verify-success" />
      <FormError message={state.status === "error" ? state.message : ""} testId="verify-error" />
    </AuthLayout>
  );
}
